import React from 'react'
import { BodyExpandableLine } from './BodyExpandableLine'
import { BodyLine } from './BodyLine'
import { BodyStyle } from './styles'

export enum FormTestId {
  INPUT_MASK = 'input-mask',
  INPUT = 'input',
  SELECT_TEXT_COUNT = 'select-text-count-results',
  SELECT_OPTION_ERROR = 'select-option-error',
  SELECT_OPTION_ITEM = 'select-option-item',
  SELECT_INPUT_WRAPPER = 'select-input-wrapper',
  SELECT_INPUT = 'select-input',
  SELECT_ERROR = 'select-error',
  TABLE_LINE = 'table-line',
  TABLE_ERROR = 'table-error'
}

interface Column {
  key: string
  width?: string
  minWidth?: string
  onClick?: (cellProp: any) => void
  Component?: (data: any) => JSX.Element
}

interface BodyProps {
  model: Column[]
  data: any[]
  lineHeight?: string
  noHover?: boolean
  isLoading: boolean
  background?: string
  rowSeparator?: boolean
  maxHeight?: string
}

export const Body = ({
  maxHeight,
  model,
  data,
  lineHeight,
  noHover,
  isLoading,
  rowSeparator,
  background
}: BodyProps): JSX.Element => {
  return (
    <BodyStyle maxHeight={maxHeight} isLoading={isLoading} background={background}>
      {data?.map((item: any, i: number) => {
        if (item?.expandable) {
          return (
            <BodyExpandableLine
              key={i}
              item={item}
              noHover={noHover}
              rowSeparator={rowSeparator}
              lineHeight={lineHeight}
              model={model}
            />
          )
        }
        return (
          <BodyLine
            key={i}
            item={item}
            noHover={noHover}
            rowSeparator={rowSeparator}
            lineHeight={lineHeight}
            model={model}
          />
        )
      })}
    </BodyStyle>
  )
}
